import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FiCalendar, FiArrowRight } from 'react-icons/fi';
import { getAssetUrl } from '../../utils/api';

const BlogCard = ({ post }) => {
  const imageUrl = post.image ? getAssetUrl(post.image) : '/placeholder-blog.svg';

  const blogId = post.slug || post._id || post.id;
  const displayDate = post.createdAt ? new Date(post.createdAt).toLocaleDateString() : (post.date || 'Recent');

  return (
    <CardContainer
      whileHover={{ y: -10 }}
      transition={{ duration: 0.3 }}
    >
      <CardImage>
        <img src={imageUrl} alt={post.title} />
      </CardImage>
      <CardContent>
        <CardDate>
          <FiCalendar />
          <span>{displayDate}</span>
        </CardDate>
        <CardTitle>
          <Link to={`/blog/${blogId}`}>{post.title}</Link>
        </CardTitle>
        <CardExcerpt>{post.excerpt}</CardExcerpt>
        <ReadMoreLink to={`/blog/${blogId}`}>
          Read More <FiArrowRight />
        </ReadMoreLink>
      </CardContent>
    </CardContainer>
  );
};

const CardContainer = styled(motion.div)`
  border-radius: var(--border-radius);
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .light & {
    background-color: var(--bg-primary-light);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .dark & {
    background-color: var(--bg-secondary-dark);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  }
`;

const CardImage = styled.div`
  overflow: hidden;
  
  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
  
  ${CardContainer}:hover & img {
    transform: scale(1.05);
  }
`;

const CardContent = styled.div`
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const CardDate = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
  
  .light & {
    color: var(--text-secondary-light);
  }
  
  .dark & {
    color: var(--text-secondary-dark);
  }
`;

const CardTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
  
  a {
    .light & {
      color: var(--text-primary-light);
    }
    
    .dark & {
      color: var(--text-primary-dark);
    }
    
    &:hover {
      .light & {
        color: var(--primary-light);
      }
      
      .dark & {
        color: var(--primary-dark);
      }
    }
  }
`;

const CardExcerpt = styled.p`
  margin-bottom: 1.5rem;
  flex: 1;
  
  .light & {
    color: var(--text-secondary-light);
  }
  
  .dark & {
    color: var(--text-secondary-dark);
  }
`;

const ReadMoreLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  margin-top: auto;
  
  .light & {
    color: var(--primary-light);
  }
  
  .dark & {
    color: var(--primary-dark);
  }
  
  svg {
    transition: transform 0.3s ease;
  }
  
  &:hover svg {
    transform: translateX(5px);
  }
`;

export default BlogCard;